module.exports = __webpack_public_path__ + "static/media/detour.ff1542da.webp";